import React, { useState, useEffect } from 'react';
import { getCategories } from '../api/service';
import Sidebar from './Sidebar';
import CategoryItems from './CategoryItems';

function Home() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = await getCategories();
        setCategories(data);
        localStorage.setItem('categories', JSON.stringify(data));
        if (data.length > 0) setSelectedCategory(data[0]);
        
      } catch (error) {
        console.error('Failed to fetch categories:', error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <div className="d-flex min-vh-100">
      <Sidebar
        categories={categories}
        setCategories={setCategories}
        setSelectedCategory={setSelectedCategory}
      />
      <div className="flex-grow-1 p-4">
        {selectedCategory ? (
          <CategoryItems category={selectedCategory} setCategories={setCategories} />
        ) : (
          <p className="text-center mt-5">Select a category to view items.</p>
        )}
      </div>
    </div>
  );
}

export default Home;